import { EntityName } from 'record-it-time-common/EntityName';
import { TimeTrackingActivity } from '../../../classes/entities/TimeTrackingActivity/timeTrackingActivityTypes';
import { useEntityDeleteHandler } from './useEntityDeleteHandler';
export function useTimeTrackingActivityDeleteHandler(timeTrackingActivity) {
  return useEntityDeleteHandler(EntityName.TimeTrackingActivity, timeTrackingActivity, _temp);
}
function _temp(activity) {
  return activity.name;
}